import { AuditLogEvent } from './../types';
import { userMapper } from './folder-parser';

export const messageAuditLogParser = data => {
  const mappedUsers = Object.keys(data.users || {}).map((userId: string) => ({
    ...userMapper(data.users[userId]),
    id: userId
  }));

  const timeline: AuditLogEvent = (data.timeline || []).map(timelineData => ({
    userId: timelineData.user_id,
    currentState: getMessageStateName(timelineData.current_state),
    previousState: getMessageStateName(timelineData.previous_state),
    action: timelineData.action,
    published: timelineData.published,
    timestamp: timelineData.timestamp * 1000
  }));

  return {
    users: mappedUsers,
    timeline
  };
};

function getMessageStateName(messageState: string) {
  return messageState === 'blocked' ? 'rejected' : messageState;
}
